<div class="apg-panel">
  <div class="apg-loading" *ngIf="loading">
    <p>Processing...</p>
    <ion-spinner></ion-spinner>
  </div>

  <ng-container [ngSwitch]="mode" *ngIf="!loading">
    <app-site-content [key]="contentKey" [appScrollIntoView]="true" showTitle="false"> </app-site-content>
  </ng-container>
</div>
